<template>
  <el-drawer :title="data.FullName" :visible.sync="drawer" size="50%">
    <el-cotainer>
      <el-main>
        <el-row>
          <el-form :model="data" size="mini">
            <el-form-item label="Nombre">
              <el-col :span="5">
                <el-input v-model="data.FullName"></el-input>
              </el-col>
              <el-col :span="5">
                <el-input v-model="data.FullName"></el-input>
              </el-col>
            </el-form-item>

            <el-row :gutter="5">
              <el-col :span="5">
                <el-form-item label="Nombre">
                  <el-input v-model="data.FullName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="5">
                <el-form-item label="Nombre">
                  <el-input v-model="data.FullName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">Create</el-button>
              <el-button @click="drawer = false">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-main>
    </el-cotainer>
  </el-drawer>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      drawer: false
    };
  },
  methods: {
    show(data) {
      this.data = data;
      this.drawer = true;
    }
  }
};
</script>

<style></style>
